// import { formatValueCost } from '../utils/functionUtils'

export const DATE_FORMAT = 'dd/MM/yyyy'
export const DD_MM_YYYY_FORMAT = 'DD/MM/YYYY'
export const ACCESS_TOKEN = 'access_token'
export const ROLE = 'role'
export const SUB_ROLE = 'subrole'
export const PAGE_MODE = {
  NEW: 'NEW',
  VIEW: 'VIEW',
  EDIT: 'EDIT',
}

export const REGEX_YYYY_MM_DD = /^\d{4}-\d{2}-\d{2}/
export const DDMMYY_HHmm = 'DD/MM/YY HH:mm'
export const YYYYMMDD_HHmmss = 'YYYY-MM-DD HH:mm:ss'
export const YYYYMMDD_T_HHmmss = 'YYYY-MM-DD[T]HH:mm:ss[Z]'
export const SUPERADMIN = 'superadmin'
export const ADMIN = 'admin'
export const DISTRIBUTOR = 'distributor'
export const CUSTOMER = 'customer'
export const KETOAN = 'ketoan'
export const BAOHANH = 'baohanh'
export const KINHDOANH = 'kinhdoanh'

export const PRODUCT = 'product'
export const ACCOUNT = 'account'
export const USER_NAME = 'username'

export const ACTIVED = 'actived'
export const EXPIRED = 'expired'

export const ADD = 'add'
export const UPDATE = 'update'
export const SUCCESS = 'success'

export const UPLOAD_IMPORT = 'import'
export const UPLOAD_EXPORT = 'export'

export const REGEX_PHONE_NUMBER = /^\d{10}$/

export const PAGE_LIMIT = 10

export const defaultOption = {
  id: 0,
  name: 'Chọn một giá trị',
  value: '',
}

export const ADMIN_ACCESS = [
  '/thong-ke',
  '/danh-muc',
  '/san-pham',
  '/khach-hang',
  '/kich-hoat',
  '/bao-hanh',
  '/dai-ly',
  '/tin-tuc',
  '/link-san-pham',
  '/tai-khoan',
]
export const ACCOUNTANT_ACCESS = ['/thong-ke', '/danh-muc', '/san-pham', '/dai-ly']
export const SALE_ACCESS = [
  '/thong-ke',
  '/danh-muc',
  '/san-pham',
  '/khach-hang',
  '/kich-hoat',
  '/bao-hanh',
  '/dai-ly',
  '/tin-tuc',
  '/link-san-pham',
]
export const WARRANTY_ACCESS = ['/thong-ke', '/khach-hang', '/kich-hoat', '/bao-hanh']
export const DISTRIBUTOR_ACCESS = [
  '/thong-ke',
  '/danh-muc',
  '/san-pham',
  '/khach-hang',
  '/kich-hoat',
  '/bao-hanh',
  '/dai-ly',
  '/tin-tuc',
  '/link-san-pham',
]
export const CUSTOMER_ACCESS = ['/thong-ke', '/san-pham']
